import { Base64 } from "js-base64";

class CryptoUtil {

  /**
   * 将字符串加密成base64
   * @param str 加密字符串
   */
  public static base64Encode(str: string, safe = true): string {
    return Base64.encode(str, safe);
  }
  /**
   * 将base64字符串解密
   * @param str 解密字符串
   */
  public static base64Decode(str: string): string {
    return Base64.decode(str);
  }
  /**
   * 获取一个唯一id字符串
   */
  public static getUuid() {
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }
  /**
   * 编码字符串，防止emoji报错
   * @param str 字符串
   */
  public static encodeStr(str: string): string {
    return encodeURIComponent(str);
  }
  /**
   * 解码字符串
   * @param str 字符串
   */
  public static decodeStr(str: string): string {
    return decodeURIComponent(str);
  }
  /**
   * 加密解密json中的字符串，防止特殊字符
   * @param jsonObj json对象
   * @param decode 是否解密
   */
  public static parseJson(jsonObj: any, decode: boolean = false) {
    if (typeof jsonObj !== "object") return;
    // 循环所有键
    for (var key in jsonObj) {
      //如果对象类型为object类型且数组长度大于0 或者 是对象 ，继续递归解析
      var element = jsonObj[key];
      if (typeof (element) == "object") {
        if ((element instanceof Array) && element.length === 0) {
          return;
        }
        CryptoUtil.parseJson(element, decode);
      } else { //不是对象或数组、直接输出
        if (typeof jsonObj[key] === "string") {
          let fn = (decode ? CryptoUtil.decodeStr : CryptoUtil.encodeStr);
          jsonObj[key] = fn(jsonObj[key])
        }
      }

    }
  }
  // 混淆加密
  public static mixEncrpt = (text: string) => {
      const mixStr = this.generateRandomString(5) + text + this.generateRandomString(6);
      return mixStr;
  }

  // 混淆解密
  public static mixDecrpt = (text: string) => {
      let str = text;
      try{
          str = str.substring(5);
          str = str.substring(0, str.length - 6);
      }catch(e){
          return "";
      }
      return str;
  }
  // 生成指定长度的随机字符串
  public static generateRandomString = (length: number) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  // 获取随机几位字符
  public static randomString(len: number) {
    len = len || 32;
    let $chars = '0123456789';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let maxPos = $chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }
}

export default CryptoUtil